import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import Security from '@/components/layouts/Security.vue';
import store from '@/store/index.js';

const routes = [
  {
    path: '/',
    name: 'Security',
    component: Security,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'Home',
        component: Home,
      },
      {
        path: '/invite/:invitationCode([a-zA-Z0-9]{8})',
        name: 'EventInvite',
        component: () => import('@/views/events/EventInvite.vue'),
      },
      {
        path: '/events/create',
        name: 'EventCreate',
        component: () => import('@/views/events/EventCreate.vue'),
      },
      {
        path: '/events/:eventId([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})',
        name: 'Event',
        component: () => import('@/views/events/Event.vue'),
      },
      {
        path: '/wishlist',
        name: 'MyWishlist',
        component: () => import('@/views/wishlist/MyWishlist.vue'),
      },
      {
        path: '/wishlist/user/:userId',
        name: 'UserWishlist',
        component: () => import('@/views/wishlist/UserWishlist.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('@/views/auth/Logout.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
  },
  {
    path: '/recovery',
    name: 'Recovery',
    component: () => import('@/views/auth/Recovery.vue'),
  },
  {
    path: '/confirm',
    name: 'ConfirmAccount',
    component: () => import('@/views/auth/ConfirmAccount.vue'),
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPassword.vue'),
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/auth/Auth.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['auth/isAuthenticated']) {
      next();
      return;
    }
    localStorage.setItem('after_auth_path', to.path);
    next('/login');
  } else {
    next();
  }
});

export default router;
